package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.WandStarsW500Rounded: ImageVector
    get() {
        if (_wandStarsW500Rounded != null) {
            return _wandStarsW500Rounded!!
        }
        _wandStarsW500Rounded = Builder(name = "WandStarsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(647.91f, 525.83f)
                lineTo(558.8f, 668.61f)
                quadToRelative(-11.0f, 17.24f, -30.73f, 14.12f)
                quadToRelative(-19.74f, -3.12f, -24.74f, -23.12f)
                lineToRelative(-27.76f, -111.04f)
                lineTo(207.59f, 816.3f)
                quadToRelative(-12.92f, 12.68f, -31.45f, 13.18f)
                reflectiveQuadToRelative(-32.21f, -13.18f)
                quadToRelative(-12.91f, -12.91f, -12.91f, -31.94f)
                reflectiveQuadToRelative(12.91f, -31.95f)
                lineToRelative(267.98f, -268.74f)
                lineToRelative(-111.52f, -27.76f)
                quadToRelative(-20.0f, -5.0f, -23.12f, -24.74f)
                quadToRelative(-3.12f, -19.74f, 14.12f, -30.74f)
                lineToRelative(142.78f, -88.34f)
                lineToRelative(-12.47f, -168.26f)
                quadToRelative(-2.0f, -20.24f, 16.23f, -29.48f)
                quadToRelative(18.24f, -9.24f, 33.48f, 4.0f)
                lineToRelative(129.07f, 108.58f)
                lineToRelative(156.26f, -63.15f)
                quadToRelative(19.24f, -8.0f, 33.36f, 6.12f)
                quadToRelative(14.12f, 14.12f, 6.12f, 33.36f)
                lineToRelative(-63.15f, 156.02f)
                lineToRelative(108.58f, 128.55f)
                quadToRelative(13.24f, 15.24f, 4.12f, 33.47f)
                quadToRelative(-9.12f, 18.24f, -29.36f, 16.24f)
                lineToRelative(-168.5f, -11.71f)
                close()
                moveTo(127.78f, 255.43f)
                quadToRelative(-6.71f, -6.71f, -6.71f, -15.91f)
                quadToRelative(0.0f, -9.19f, 6.71f, -15.91f)
                lineToRelative(55.83f, -55.83f)
                quadToRelative(6.72f, -6.71f, 15.91f, -6.71f)
                quadToRelative(9.2f, 0.0f, 15.91f, 6.71f)
                lineToRelative(55.59f, 55.59f)
                quadToRelative(6.72f, 6.72f, 6.72f, 15.91f)
                quadToRelative(0.0f, 9.2f, -6.72f, 15.92f)
                lineToRelative(-55.82f, 55.82f)
                quadToRelative(-6.72f, 6.72f, -15.92f, 6.72f)
                quadToRelative(-9.19f, 0.0f, -15.91f, -6.72f)
                lineToRelative(-55.59f, -55.59f)
                close()
                moveTo(555.72f, 511.02f)
                lineTo(601.8f, 435.85f)
                lineTo(690.5f, 442.37f)
                lineTo(633.13f, 374.72f)
                lineTo(666.7f, 292.54f)
                lineTo(584.52f, 325.87f)
                lineTo(516.63f, 269.5f)
                lineTo(523.39f, 357.43f)
                lineTo(447.98f, 404.04f)
                lineTo(533.91f, 425.09f)
                lineTo(555.72f, 511.02f)
                close()
                moveTo(704.8f, 832.22f)
                lineTo(648.98f, 776.63f)
                quadToRelative(-6.72f, -6.72f, -6.72f, -15.91f)
                quadToRelative(0.0f, -9.2f, 6.72f, -15.92f)
                lineToRelative(55.59f, -55.58f)
                quadToRelative(6.71f, -6.72f, 15.91f, -6.72f)
                quadToRelative(9.19f, 0.0f, 15.91f, 6.72f)
                lineToRelative(55.83f, 55.58f)
                quadToRelative(6.71f, 6.72f, 6.71f, 15.92f)
                quadToRelative(0.0f, 9.19f, -6.71f, 15.91f)
                lineToRelative(-55.59f, 55.59f)
                quadToRelative(-6.72f, 6.71f, -15.91f, 6.71f)
                quadToRelative(-9.2f, 0.0f, -15.92f, -6.71f)
                close()
                moveTo(569.24f, 389.76f)
                close()
            }
        }
        .build()
        return _wandStarsW500Rounded!!
    }

private var _wandStarsW500Rounded: ImageVector? = null
